// extracted by mini-css-extract-plugin
module.exports = {"detailContent":"styles_detailContent__gdT3v","applicantDetail":"styles_applicantDetail__2PFSU","offerDetail":"styles_offerDetail__2A_QE"};